import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faLeftRight } from '@fortawesome/pro-light-svg-icons';

export type ProLightLeftRightProps = IconComponentProps;

export const ProLightLeftRight = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightLeftRightProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faLeftRight}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faLeftRight}
    />
  );
};

ProLightLeftRight.displayName = 'ProLightLeftRight';
